import { LoginModal } from "@components/modal"
import { container, FlexBox } from "@components/wrapper"
import { HARISENIN_LOGO, HARISENIN_LOGO_WHITE } from "@const/pictures"
import { useScreenSize } from "@hooks/useScreenSize"
import { useAnalytics } from "@lib/context/AnalyticsContext"
import { useUserData } from "@lib/context/ComponentContext"
import AuthServices from "@services/auth.services"
import clsx from "clsx"
import Image from "next/image"
import React, { useEffect, useState } from "react"
import { FaCheckCircle } from "react-icons/fa"
import { HeaderComponent } from "./components"
import HeaderMobile from "./components/HeaderMobile"

interface HeaderProps {
  transparent?: boolean
  isNotSticky?: boolean
  bgOnly?: boolean
}

export function Header({ transparent, isNotSticky, bgOnly }: HeaderProps) {
  const [loginModal, setLoginModal] = useState(false)
  const [unverifiedStatus, setUnverifiedStatus] = useState(false)
  const [isToastOpen, setIsToastOpen] = useState(false)
  const [isHover, setIsHover] = useState(false)

  const { deviceType, screenHeight } = useScreenSize()
  const { tokenData, isLogin } = useUserData()
  const auth = new AuthServices()
  const { analytics } = useAnalytics()

  useEffect(() => {
    const initIdentify = async () => {
      try {
        const res = await auth.getUserData()

        if (res.isSuccess) {
          const result = res.getValue()
          analytics.identify(tokenData?.id, result)
        }
      } catch (error) {
        console.log(error)
      }
    }

    if (!tokenData?.user_active && isLogin) {
      setUnverifiedStatus(true)
    }

    if (isLogin) {
      initIdentify()
    }
  }, [tokenData])

  const handleOpenLogin = () => {
    setLoginModal(true)
  }
  const handleCloseLogin = () => {
    setLoginModal(false)
  }

  const sendEmail = async () => {
    try {
      await auth.resendVerificationEmail(tokenData?.user_email as string)
      setIsToastOpen(true)

      setTimeout(() => setIsToastOpen(false), 3000)
    } catch (e) {
      if (process.env.NODE_ENV === "development") {
        console.log(e)
      }
    }
  }

  return (
    <>
      {deviceType === "web" ? (
        <div
          className={clsx(
            "top-0 z-[1000]",
            isHover && "bg-white text-black-48",
            isNotSticky ? "fixed" : "sticky",
            transparent && !bgOnly && "text-white",
            transparent ? `w-full fixed transition ease-in delay-150 ` : "bg-white w-full"
          )}
        >
          {/* Header Component */}
          <div className="static">
            <FlexBox align="center" justify="between" className={clsx(container, "py-4")}>
              {/* Logo */}
              <FlexBox align="center">
                <a href="/">
                  <Image
                    src={transparent && !bgOnly && !isHover ? HARISENIN_LOGO_WHITE : HARISENIN_LOGO}
                    alt="harisenin.com logo"
                    className="h-[25px] w-auto"
                    width={100}
                    height={25}
                  />
                </a>
              </FlexBox>

              <HeaderComponent
                loginModalHandler={handleOpenLogin}
                isLogin={isLogin}
                tokenData={tokenData}
                setIsHover={(e: any) => setIsHover(e)}
              />
            </FlexBox>
          </div>

          {unverifiedStatus && (
            <div className="bg-yellow px-7.5 py-2.5 text-center p-2.5">
              Akun kamu belum diverifikasi. Silahkan cek email untuk memverifikasi akun atau klik{" "}
              <u className="cursor-pointer" onClick={sendEmail}>
                disini
              </u>{" "}
              bila email verifikasi belum masuk di inbox kamu. <br />
              Bila kamu telah melakukan verifikasi dan notifikasi belum hilang, silahkan coba login
              ulang
            </div>
          )}

          <FlexBox
            justify="center"
            align="center"
            className={clsx(
              "z-[1000] fixed top-[50px] left-1/2 w-[300px] ml-[-150px] bg-green text-white rounded text-center p-3 lg:text-base text-sm gap-2",
              isToastOpen ? "visible show_toast" : "invisible"
            )}
          >
            <FaCheckCircle /> Email Verifikasi berhasil dikirim
          </FlexBox>
        </div>
      ) : (
        <HeaderMobile
          loginModalHandler={handleOpenLogin}
          isLogin={isLogin}
          tokenData={tokenData}
          screenHeight={screenHeight}
        />
      )}

      <LoginModal show={loginModal} onClose={handleCloseLogin} />
    </>
  )
}
